import { useReactive } from "@supergrain/kernel/react"
import type { ReactNode } from "react"
import { UnifiedTiptapUiContext, type UnifiedTiptapUiValue } from "./unified-tiptap-ui-context"

export const UnifiedTiptapUiProvider = ({
  value,
  children,
}: {
  value: UnifiedTiptapUiValue
  children?: ReactNode
}) => {
  // Use a stable reactive object for the context, re-assigning its entries each render
  // so that any changes trigger re-renders of their readers (assuming the readers are tracked).
  const context = useReactive(value)
  Object.assign(context, value)
  // Object.assign only considers value's current keys. Delete any (own string) keys that it newly omits.
  for (const key of Object.keys(context) as Array<keyof typeof context>) {
    if (!Object.hasOwn(value, key)) delete context[key]
  }
  return (
    <UnifiedTiptapUiContext.Provider value={context}>{children}</UnifiedTiptapUiContext.Provider>
  )
}
